/* @flow */

import React, { Component } from 'react';
import { Form } from 'semantic-ui-react';
import ConfirmLayoutChange from './ConfirmLayoutChange';

type Props = {
  content?: CatalogPageContent,
  hasUpdate: boolean,
  isUpdating: boolean,
  onChange: (layout: CatalogLayout) => void,
};

type State = {
  layout?: CatalogLayout,
  isLoading: boolean,
};

const getLayoutsOptions = layouts =>
  layouts.map(l => ({
    value: l.code,
    text: l.name,
  }));

class LayoutsSelector extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      isLoading: false,
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    if (
      nextProps.isUpdating !== this.props.isUpdating &&
      !nextProps.isUpdating
    ) {
      this.setState({
        isLoading: false,
        layout: undefined,
      });
    }
  }

  layoutChanged = (_, { value }) => {
    const { content } = this.props;
    const layout = content.layouts.find(l => l.code === value);

    if (layout && content.layout.code !== layout.code) {
      this.setState({ layout });
    }
  };

  cancelChange = () => this.setState({ layout: undefined });

  confirmChange = () => {
    const { layout } = this.state;
    if (layout) {
      this.props.onChange(layout);
    }
  };

  render() {
    const { content, hasUpdate, isUpdating } = this.props;
    const { layout, isLoading } = this.state;

    if (content && content.layouts && content.layouts.length) {
      const currentLayout = layout ? layout.code : content.layout.code;

      return (
        <div>
          <Form.Select
            label={`Mise en page`}
            disabled={hasUpdate || isUpdating}
            value={currentLayout}
            options={getLayoutsOptions(content.layouts)}
            onChange={this.layoutChanged}
          />
          <ConfirmLayoutChange
            open={!!layout}
            loading={isLoading || isUpdating}
            onClose={this.cancelChange}
            onConfirm={this.confirmChange}
          />
        </div>
      );
    }

    return null;
  }
}

export default LayoutsSelector;



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Page/Edit/components/LayoutsSelector.js